exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-small[data-v-028164eb] {\n    font-size: 1em;\n}\n", ""]);

// exports
